import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';

interface DatePickerYearProps extends Omit<DatePickerProps, 'views' | 'label' | 'renderInput'> {
    label?: string;
}

/**
 * Componente data Ano com props pré-definidas
 */
export function DatePickerYear({ label = 'Ano', ...props }: DatePickerYearProps) {
    return <DatePicker views={['year']} label={label} format="yyyy" slotProps={{ textField: { autoComplete: 'off' } }} {...props} />;
}
